import {
    STUDENT,
    CUSTOMER,
    EMPLOYEE,
} from './_types';

const userAccountType = (state) => {
    const { user: currentUser } = state;

    if (!currentUser) {
        return null;
    }

    const { account_type: accountType } = currentUser;

    if (!accountType) {
        return null;
    }

    return accountType.split('\\').pop().toUpperCase();
};

export default {
    isLoggedIn: state => state.isLoggedIn && !!state.user,

    currentUser: state => state.user,

    currentUserAccount: (state) => {
        if (!state.user) {
            return null;
        }

        return state.user.account || null;
    },

    isStudent: state => userAccountType(state) === STUDENT,

    isCustomer: state => userAccountType(state) === CUSTOMER,

    isEmployee: state => userAccountType(state) === EMPLOYEE,

    userAccountType,
};



// WEBPACK FOOTER //
// ./src/infrastructure/auth/store/_getters.js